'use client';

import { Suspense } from 'react';
import BookingPageContent from './BookingPageContent';

export default function BookingPage() {
  return (
    <Suspense fallback={<div className="min-h-screen bg-[var(--background)] flex items-center justify-center"><div className="text-[var(--muted-foreground)]">Loading booking...</div></div>}>
      <BookingPageContent />
    </Suspense>
  );
}
